import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../../../../../../core/services/auth.service';
import { unsubscribeFromAll } from '../../../../../../../../core/pure-functions/rx-helper';
import { Subscription } from 'rxjs';
import { ContainsSubscriptions } from '../../../../../../../../core/services/interfaces/contains-subscriptions';
import { VesselDAO } from '../../../../../../../../core/services/dao/vesselDAO';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';

@Component({
  selector: 'app-calendar-connect-dialog',
  templateUrl: './calendar-connect-dialog.component.html',
  styleUrls: ['./calendar-connect-dialog.component.scss'],
})
export class CalendarConnectDialogComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  googleIcon: string =
    'https://anchor-public-media.s3.us-east-2.amazonaws.com/prod/Google_Calendar_icon.svg.png';
  youTubeLink: string = 'https://www.youtube.com/watch?v=hVG9F6552BU';
  googleUrl: string;
  isMobile: boolean;
  hasOAuth: boolean = false;
  vessel: Vessel;
  originalSelectedCalendarId: string;
  availableCalendars: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public calendarData: any,
    private dialogRef: MatDialogRef<CalendarConnectDialogComponent>,
    private authService: AuthService,
    private vesselDAO: VesselDAO,
  ) {
    this.vessel = this.calendarData.vessel;
    this.originalSelectedCalendarId = this.vessel.calendarId;
  }

  ngOnInit() {
    this.hasOAuth = !!this.calendarData.boatOwner.googleAccessToken;
    if (this.hasOAuth) {
      this.getCalOptions();
    } else {
      this.getGoogleAuthUrl();
    }
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  cancel() {
    this.dialogRef.close();
  }

  private getGoogleAuthUrl(): void {
    let flow = 'calendar';
    const googleAuthUrlSub = this.authService
      .getGoogleAuthUrl(
        {
          vesselId: this.calendarData.vesselId,
          flow,
        },
        flow,
      )
      .subscribe((result) => {
        console.log(result);
        this.googleUrl = result.authUrl;
      });
    this.subs.push(googleAuthUrlSub);
  }

  private getCalOptions(): void {
    const vesselSub = this.vesselDAO
      .getCalendarOptions(this.calendarData.vesselId)
      .subscribe((cals) => {
        this.availableCalendars = cals;
        this.availableCalendars.map((cal) => {
          if (this.originalSelectedCalendarId === cal.id) {
            cal.isUsed = false;
          }
        });
      });
    this.subs.push(vesselSub);
  }

  findCalendarSummary(): string {
    let calName;
    this.availableCalendars.map((cal) => {
      if (this.vessel.calendarId == cal.id) {
        calName = cal.summary;
      }
    });
    return calName;
  }

  saveAndClose() {
    let summary = this.findCalendarSummary();
    console.log(summary);
    this.vesselDAO
      .updateFromPartial(this.vessel.id, {
        calendarId: this.vessel.calendarId,
        calendarSummary: summary,
      })
      .subscribe(() => {
        this.dialogRef.close({
          calendarId: this.vessel.calendarId,
          calendarSummary: summary,
        });
      });
  }
}
